import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "./SignUp.css"; // Importing the CSS file

function SignUp() {
    const [phoneNumber, setPhoneNumber] = useState("");
  const navigate = useNavigate(); // Hook for navigation

  const handleInputChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  const handleOTPRequest = () => {
    if (phoneNumber.length === 10) {
      alert(`OTP sent to ${phoneNumber}`);
      window.location.href = "https://dashboard-sj2j-dun.vercel.app/"; // ✅ Change this to the Dashboard URL
    } else {
      alert("Please enter a valid 10-digit mobile number");
    }
  };
    return ( 
        <div className="signup-container">
      <h1 className="signup-heading">
        Open a free demat & trading account online
      </h1>
      <p className="signup-subtext">
        Start investing brokerage free and join a community of 1.5+ crore investors and traders
      </p>

      <div className="signup-box">
        <div className="signup-left">
          <img
            src="media/images/signup.svg"
            alt="Trading dashboard"
            className="signup-image"
          />
        </div>

        <div className="signup-right">
          <h2 className="signup-now">Signup now</h2>
          <p className="signup-track">Or track your existing application</p>

          <div className="input-container">
            <span className="country-code">🇮🇳 +91</span>
            <input
              type="text"
              placeholder="Enter your mobile number"
              className="phone-input"
              value={phoneNumber}
              onChange={handleInputChange}
            />
          </div>

          <button className="otp-button" onClick={handleOTPRequest}>
            Get OTP
          </button>

          <p className="signup-footer">
            By proceeding, you agree to the{" "}
            <a href="#" className="signup-link">
              Zerodha terms
            </a>{" "}
            &{" "}
            <a href="#" className="signup-link">
              privacy policy
            </a>
          </p>
        </div>
      </div>
    </div>
     );
}

export default SignUp;